import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";

const SmsTerms = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white">
      <div className="max-w-3xl mx-auto px-6 py-16">
        <Button variant="ghost" className="mb-6 text-stone-500" onClick={() => navigate(-1)}>
          &larr; Back
        </Button>

        <h1 className="text-3xl font-bold text-[#1e3a5f] mb-2">SMS Terms & Conditions</h1>
        <p className="text-sm text-stone-400 mb-8">Effective Date: April 10, 2026</p>

        <div className="prose prose-stone max-w-none space-y-6 text-stone-700 text-sm leading-relaxed">
          <section>
            <h2 className="text-lg font-semibold text-[#1e3a5f]">1. Program Description</h2>
            <p>
              Opturna Tax AI&#8482; ("Opturna," "we," "us") offers an optional SMS notification service to help you manage your business finances.
              By opting in, you consent to receive automated text messages related to:
            </p>
            <ul className="list-disc pl-6 space-y-1">
              <li>Profit allocation reminders (10th and 25th of each month)</li>
              <li>Tax payment deadline reminders</li>
              <li>Account balance alerts</li>
              <li>Financial health updates</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#1e3a5f]">2. Opt-In & Consent</h2>
            <p>
              By enabling SMS Reminders in your Opturna Tax AI&#8482; account settings and providing your phone number, you expressly consent to receive recurring automated text messages from Opturna Tax AI&#8482; at the phone number you provide. Consent is not a condition of purchase or use of the platform.
            </p>
            <p>
              You may opt in by navigating to <strong>Settings &rarr; Reminders &rarr; SMS Reminders</strong> and toggling the SMS option on, entering your phone number, and checking the consent box.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#1e3a5f]">3. Message Frequency</h2>
            <p>
              Message frequency varies based on your reminder preferences. Typically, you will receive 2–4 messages per month (allocation reminders on the 9th, 10th, 24th, and 25th). Additional messages may be sent for tax deadline reminders or urgent financial alerts.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#1e3a5f]">4. Message & Data Rates</h2>
            <p>
              Message and data rates may apply. Opturna Tax AI&#8482; does not charge for SMS messages, but your mobile carrier's standard messaging rates will apply.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#1e3a5f]">5. Opt-Out</h2>
            <p>
              You can opt out of SMS notifications at any time by:
            </p>
            <ul className="list-disc pl-6 space-y-1">
              <li>Replying <strong>STOP</strong> to any message you receive from us</li>
              <li>Toggling off SMS Reminders in your account Settings</li>
              <li>Contacting us at <a href="mailto:info@opturnatech.com" className="text-[#1e3a5f] underline">info@opturnatech.com</a></li>
            </ul>
            <p>After opting out, you will receive one final confirmation message and no further SMS messages.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#1e3a5f]">6. Help</h2>
            <p>
              For assistance, reply <strong>HELP</strong> to any message or contact us at <a href="mailto:info@opturnatech.com" className="text-[#1e3a5f] underline">info@opturnatech.com</a>.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#1e3a5f]">7. Privacy</h2>
            <p>
              Your phone number and SMS preferences are stored securely and will never be sold to third parties. We use your phone number solely to deliver the notifications you requested. For more details, see our <a href="/privacy" className="text-[#1e3a5f] underline">Privacy Policy</a>.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#1e3a5f]">8. Supported Carriers</h2>
            <p>
              SMS notifications are supported on all major US carriers including AT&T, Verizon, T-Mobile, Sprint, and others. Carriers are not liable for delayed or undelivered messages.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#1e3a5f]">9. Contact Information</h2>
            <p>
              Opturna Tax AI&#8482;<br />
              Email: <a href="mailto:info@opturnatech.com" className="text-[#1e3a5f] underline">info@opturnatech.com</a><br />
              Website: <a href="https://opturnatech.com" className="text-[#1e3a5f] underline">opturnatech.com</a>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default SmsTerms;
